import * as React from 'react';
import { Column, Row } from '../../../../../../shared/components/Grid/Grid';
import { t } from '../../../../../../shared/components/l10n/l10n';
import { Toggle } from '@economic/gaudi';

interface Props {
    offerToggled: boolean;
    onToggle: (isToggled: boolean) => void;
}

export default function MoneyflowActivationWidget({ offerToggled, onToggle }: Props) {
    return (
        <div className="shadow-md p-3 ml-12 mr-12">
            <Row>
                <Column xs="1">
                    <div className="bg-green rounded-full w-3 h-3 mt-3 ml-2" />
                </Column>
                <Column xs="9">
                    <div className="leading-4">{t`FORM_BOOKANDSEND_MONEYFLOW_REVIEWOFFER_WIDGET_ACTIVATE`}</div>
                </Column>
                <Column xs="2">
                    <Toggle checked={offerToggled} onChange={() => onToggle(!offerToggled)} />
                </Column>
            </Row>
        </div>
    );
}
